import { reactive, toRefs, ref } from 'vue'
import apiUser from '../api/user.api'

const state = reactive({
  userList: [],
  filterOptions: {},
  loading: false,
  pagination: ref({
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 0
  }),
  paginationInfoLoading: false
})

const getSummary = async (params) => {
  state.paginationInfoLoading = true

  try {
    const { data: { total } } = await apiUser.getTotal(params)

    state.pagination.rowsNumber = total
  } catch {
  } finally {
    state.paginationInfoLoading = false
  }
}

export default function useUser() {

  const getUserList = async (params) => {
    state.loading = true
    getSummary(params)
    const { data } = await apiUser.getList(params)
    state.userList = Object.freeze(data)
    state.filterOptions = params

    state.pagination.page = params?.page ? params.page : 1
    state.pagination.rowsPerPage = params["page-size"] ? params["page-size"] : 20

    state.loading = false
  }

  return {
    ...toRefs(state),
    getUserList
  }
}